import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';

import styles from '../Page.module.scss';
import historyStyles from './History.module.scss';
import MainWrapper from '../Utils/MainWrapper';
import ClickableItem from '../Utils/ClickableItem';

function HistoryItem({
  title, url, visited,
}) {
  return (
    <ClickableItem url={url}>
      <span className={historyStyles.time}>
        {visited.getHours()}
        :
        {String(visited.getMinutes()).padStart(2, '0')}
      </span>
      <span className={styles.title}>{title}</span>
      <span className={styles.url}>{url}</span>
    </ClickableItem>
  );
}

HistoryItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  visited: PropTypes.instanceOf(Date).isRequired,
};

const options = {
  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
};

function HistoryTitle({ visited, count, locale }) {
  return (
    <div className={styles.listTitle}>
      <span>
        {visited.toLocaleDateString(locale, options)}
      </span>
      <span>{count}</span>
    </div>
  );
}

HistoryTitle.propTypes = {
  visited: PropTypes.instanceOf(Date).isRequired,
  count: PropTypes.number.isRequired,
  locale: PropTypes.string,
};

HistoryTitle.defaultProps = {
  locale: 'en',
};

const PREFETCH_COUNT = 15;

function History({ history }) {
  const { t } = useTranslation();
  const [bottom, setBottom] = useState(1);
  const [bottomItem, setBottomItem] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function loadMore() {
    const newBottomItem = bottomItem + PREFETCH_COUNT;
    const lastDay = history[bottom - 1];

    if (lastDay && newBottomItem < lastDay.length) {
      setBottomItem(newBottomItem);
    } else {
      setBottom(bottom + 1);
      setBottomItem(0);
    }
  }

  const locale = localStorage.getItem('i18nextLng');

  return (
    <MainWrapper caption={t('History')}>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={bottom <= history.length}
      >
        {history.slice(0, bottom - 1).map((d) => (
          <div key={`day_${d[0].id}`} className={styles.list}>
            <HistoryTitle visited={d[0].visited} count={d.length} locale={locale} />
            {d.map((h) => (
              <HistoryItem
                key={h.id}
                title={h.title}
                url={h.url}
                visited={h.visited}
              />
            ))}
          </div>
        ))}
        {history.slice(bottom - 1, bottom).map((d) => (
          <div key={`day_${d[0].id}`} className={styles.list}>
            <HistoryTitle visited={d[0].visited} count={d.length} />
            {d.slice(0, bottomItem).map((h) => (
              <HistoryItem
                key={h.id}
                title={h.title}
                url={h.url}
                visited={h.visited}
              />
            ))}
          </div>
        ))}
      </InfiniteScroll>
    </MainWrapper>
  );
}

History.propTypes = {
  history: PropTypes.instanceOf(Array).isRequired,
};

export default History;
